module.exports = __webpack_public_path__ + "assets/cf11d8d5b5f0dec71002be6822c15a86.mp3";